import { Controller } from '@hotwired/stimulus';
import Axios from "../axios";

export default class extends Controller {
    connect() {
        this.onScrollRunning = false;
        this.boundingClientRect = this.element.getBoundingClientRect();
        this.currentLanguageCode = document.documentElement.lang.split('-')[0];

        this.filters = {};
        this.type = this.element.dataset.type;
        this.from = this.element.dataset.from ? this.element.dataset.from : 0;
        this.limit = this.element.dataset.from ? this.element.dataset.limit : 9;
        this.total = this.element.dataset.total ? this.element.dataset.total : -1;
        if (this.element.dataset.filter) {
            this.filters = JSON.parse(this.element.dataset.filter);
        }
    }

    onScroll() {
        if (!this.onScrollRunning) {
            if (window.scrollY >= this.boundingClientRect.top) {
                this.onScrollRunning = true;
                this.fetchPosts().then(response => {
                    if (response && response.data) {
                        this.insertContent(response.data);
                        this.from = response.from;
                        this.onScrollRunning = false;
                    }
                });
            }
        }
    }

    async fetchPosts() {
        if (parseInt(this.from) >= parseInt(this.total) && parseInt(this.total) > 0) {
            return '';
        }

        this.element.classList.add('loading');

        const data = {
            rest_language: this.currentLanguageCode,
            type: this.type,
            from: this.from,
            limit: this.limit,
            filters: JSON.stringify(this.filters),
        };

        const params = Object.keys(data).map(function (k) {
            return `${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`;
        }).join('&');

        let response = null;
        try {
            response = await Axios.get(`/wp-json/api/fetch-posts/?${params}`);
            response = response.data.data;
        } catch (error) {
            response = error.response.data.data;
        }

        this.element.classList.remove('loading');
        return response;
    }

    emptyContent() {
        this.element.innerHTML = '';
    }

    insertContent(html) {
        this.element.insertAdjacentHTML('beforeend', html);
    }
}
